module.exports = __webpack_public_path__ + "media/promo/panasonic/images/hero-text-dc03fe7badd6ddf181852d38b5fba534.svg";